import { Button } from "@common/Button";
import { ComponentColor, ComponentSize } from "@common/types";

interface ConfirmDeleteDialogProps {
    /** What is being deleted, e.g. `Option "Color"` or `value "Red"`. */
    label: string;
    isProcessing: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmDeleteDialog = ({
    label,
    isProcessing,
    onConfirm,
    onCancel,
}: ConfirmDeleteDialogProps) => {
    return (
        <div
            role="alertdialog"
            aria-label={`Delete ${label}`}
            className="rounded-lg border border-base-300 bg-base-100 p-3 text-sm text-neutral"
        >
            <p className="mb-2">Delete {label}?</p>
            <div className="flex justify-end gap-2">
                <Button
                    color={ComponentColor.Error}
                    size={ComponentSize.SM}
                    loading={isProcessing}
                    onClick={onConfirm}
                >
                    Delete
                </Button>
                <Button
                    color={ComponentColor.Neutral}
                    size={ComponentSize.SM}
                    disabled={isProcessing}
                    onClick={onCancel}
                >
                    Cancel
                </Button>
            </div>
        </div>
    );
};
